import { Icon } from '../components/ui';
import { useSearch } from './SearchProvider';

export const isMac = typeof navigator !== 'undefined' && /mac|iphone|ipad/i.test(navigator.platform);

export function SearchTrigger({
  variant = 'bar',
  placeholder = 'Cari atau tanya AI…',
}: {
  variant?: 'bar' | 'sidebar' | 'icon';
  placeholder?: string;
}) {
  const { show } = useSearch();
  if (variant === 'icon') {
    return (
      <button type="button" className="btn btn-sm icon-btn cmdk-trigger-icon" onClick={() => show()} aria-label={placeholder}>
        <Icon name="search" size={16} />
      </button>
    );
  }
  return (
    <button type="button" className={`cmdk-trigger ${variant}`} onClick={() => show()} aria-label={placeholder} title={placeholder}>
      <Icon name="search" size={15} />
      <span className="cmdk-trigger-text">{placeholder}</span>
      <kbd>{isMac ? '⌘K' : 'Ctrl K'}</kbd>
    </button>
  );
}
